import { getSharedState as i } from "../../utilities/state/index.js";
const s = {
  menuCategories: []
}, t = i(
  "navigation",
  s
), g = () => t.get(), c = (e, o, n, a) => {
  t.switchContext({ countryCode: e, regionCode: o, brand: n }), t.set({ menuCategories: a });
}, T = () => {
  t.reset();
};
export {
  t as NAVIGATION_STATE,
  g as getNavigation,
  T as resetNavigation,
  c as setNavigation
};
//# sourceMappingURL=index2.js.map
